
exports.injectInMainCssTemplate = (...args) => require('./lib/create-main-css-util').injectInMainCssTemplate(...args)

exports.getCssForShapeId = (...args) => require('./lib/create-main-css-util').getCssForShapeId(...args)
